import lookUpReducer from "./customersSlice";

export default lookUpReducer;
